onComplete(function () {
  const COUNT_ANIMATION_DURATION = 1000;
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Stop observing the element after the animation has started.
        observer.unobserve(entry.target);
        const counterElement = entry.target.querySelector('.count-block-number');
        if (counterElement) {
          const rawText = counterElement.textContent.trim();
          // . of + moeten wel meegenomen worden.
          const match = rawText.match(/^[\d.,]+/);
          const targetNumber = match ? parseFloat(match[0].replace(/[.,]/g, '')) : 0;
          const suffix = rawText.slice(match ? match[0].length : 0);
          const count = {
            value: 0
          };
          anime({
            targets: count,
            value: targetNumber,
            easing: 'easeInOutSine',
            duration: COUNT_ANIMATION_DURATION,
            update: () => {
              counterElement.textContent = Math.round(count.value) + suffix;
            }
          });
        }
      }
    });
  }, {
    // Offset how far the element needs to be on screen before it triggers the animation.
    rootMargin: '0px 0px -32px 0px'
  });
  Array.from(document.querySelectorAll('.counters-section .count-block')).forEach(element => {
    observer.observe(element);
  });
});